import { DateTime } from "luxon";
import { useEffect, useMemo, useState } from "react";
import { nowIndicatorForAxis } from "../calendar-time-axis";

// Position of the "current time" line on the day grid. Returns nulls when now is
// outside the visible window so the caller can omit the indicator entirely.
export function useDayViewClock(timeAxis) {
  const [currentTime, setCurrentTime] = useState(() => DateTime.now());

  useEffect(() => {
    // Re-seed on every effect run: the state initializer only runs on first
    // mount, so an Activity thaw would otherwise show the freeze-time line
    // for up to a minute.
    setCurrentTime(DateTime.now());
    const timerId = window.setInterval(() => {
      setCurrentTime(DateTime.now());
    }, 60000);

    return () => window.clearInterval(timerId);
  }, []);

  const currentMinutes = useMemo(() => currentTime.hour * 60 + currentTime.minute, [currentTime]);
  const indicator = useMemo(
    () => nowIndicatorForAxis(currentMinutes, timeAxis),
    [currentMinutes, timeAxis],
  );

  return {
    currentTimeRowStart: indicator ? indicator.rowStart : null,
    currentTimeRowOffsetPercent: indicator ? indicator.rowOffsetPercent : null,
  };
}
